 if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      image_container.addEventListener('touchstart', mousemove, {
        passive: true
      });
      image_container.addEventListener('touchmove', mousemove, {
        passive: true
      });
      image_container.addEventListener('touchend', mouseleave, {
        passive: true
      });
      image_container.addEventListener('mouseenter', mousemove, {
        passive: true
      });
      image_container.addEventListener('mousemove', mousemove, {
        passive: true
      });
      image_container.addEventListener('mouseleave', mouseleave, {
        passive: true
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active');

      swatch_list.forEach((swatch, index) => {

        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');
              document.querySelector('#Product-Drawer-Content').innerHTML = '';
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      document.querySelector('#Product-Drawer-Content').innerHTML = '';
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      checkout_button = this.container.querySelector('.button.checkout');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider'),
            flkty = Flickity.data(slider);

          flkty.reposition();
        }, 100);
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}
document.addEventListener('DOMContentLoaded', function() {

  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }


  //Hacer que el srcoll en los productos de la pestaña del buscador sea horizonal cuando el buscador está abierto
  let variation = 0;
  let searchElements = document.querySelector('.side-panel.search-drawer ul.products');
  searchElements.addEventListener('wheel', function (e) {
    if(variation < 0){
      variation = 0;
    }else if(variation > (searchElements.scrollWidth-searchElements.offsetWidth)) {
      variation = searchElements.scrollWidth-searchElements.offsetWidth;
    } else {
      variation += parseInt(e.deltaY);
    }
    searchElements.scrollLeft = (variation);
    searchElements.style.cssText = 'scroll-behavior: smooth;';
    return false;
  }, true);
  //END Hacer que el srcoll en los productos de la pestaña del buscador sea horizonal cuando el buscador está abierto

  //Anticipamos el preventDefault del botón de búsqueda
  let buttonSerch = document.querySelectorAll('.thb-quick-search');
  buttonSerch.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
    });
  });
  //END Anticipamos el preventDefault del botón de búsqueda

  const footerLinks = document.querySelectorAll('.footer .thb-widget-menu li a');
  for (const enlace of footerLinks) {
      const urlElemento = enlace.href;
  
      // Verifica si la URL del elemento no contiene la URL del SignIn de CJ
      if (!urlElemento.includes('ufesa.es') && !urlElemento.includes('3f8f8f.myshopify.com')) {
        enlace.setAttribute('target', '_blank'); 
      }
  }
  
});//END DOMContentLoaded


// Oculta en versión escritorio "ver todo" megamenú
if (window.matchMedia('(min-width: 768px)').matches) {
  // Encuentra todos los elementos <a> con title="Ver todo..."
  var viewAllCategoryElements = document.querySelectorAll('a[title="Ver todo cocina"], a[title="Ver todo planchado"], a[title="Ver todo cuidado personal"], a[title="Ver todo climatización"], a[title="Ver todo aspiradoras"], a[title="Ver todo calor textil"],a[title="Ver todo calefacción"],a[title="Ver todo ventilación"]');
  // Itera a través de los elementos encontrados
  viewAllCategoryElements.forEach(function(viewAllCategory) {
    // Verifica si el elemento no tiene elementos hijos (subcategorías)
    if (viewAllCategory.nextElementSibling === null) {
      // Si no tiene elementos hijos, busca su elemento padre (el <li>) y lo oculta
      var parentLi = viewAllCategory.parentElement;

      if (parentLi) {
        parentLi.style.display = 'none'; // Oculta el <li>
      }
    }
  });
}
// Oculta el % de ahorro de la pagina de producto movil cuando está agotado
if (window.matchMedia('(max-width: 768px)').matches) {
    document.querySelectorAll('.badges').forEach(el => {
        if (el.querySelector('.badge.out-of-stock')) {
            el.querySelector('.badge.onsale').style.display = 'none';
        }
    })
}


// Evita el funcionamiento normal del primer item de promociones (bloque justo después del slider) y activa el popup de klaviyo
if (window.location.pathname === '/') {

  var is_iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  // La home no siempre lleva la sección de promociones: sin este guard el
  // script petaba aquí y no llegaba a ejecutarse nada de lo que viene después.
  var promotionItem = document.querySelector('.section-promotion-blocks .promotion-blocks--item');

  if (promotionItem) {
    if (is_iOS) {
      promotionItem.addEventListener('touchstart touchmove touchend', function (e) {
          e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'VHaRKV']);
      });
    }

    promotionItem.removeAttribute('onclick');
    promotionItem.ontouchstart = null;

    promotionItem.onclick = null;
    promotionItem.addEventListener('click', function (e){
      e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'VHaRKV']);
    });
  }



  /*Cambiar url del video slide en mobile*/
  /* const videoMobileHtml3 = `<video playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="metadata" poster="//www.ufesa.es/cdn/shop/files/preview_images/0a696386bab74074a761e6bc0d26d2fa.thumbnail.0000000000_small.jpg?v=1748269807"><source src="https://cdn.shopify.com/videos/c/o/v/88007da908af4df9b91c3051af49dc0f.mp4" type="video/mp4"><img src="//www.ufesa.es/cdn/shop/files/preview_images/0a696386bab74074a761e6bc0d26d2fa.thumbnail.0000000000_small.jpg?v=1748269807"></video>`;
  const videoData3 = document.querySelectorAll('.flickity-slider .slideshow__slide:nth-child(1) .slideshow__slide-video-bg');

  if (window.matchMedia('(max-width: 768px)').matches) {
    videoData3[0].innerHTML = videoMobileHtml3;
  }  */

  /*Check href button and add class to closest slide chosen */
  const slideshowButtons = document.querySelectorAll('.slideshow__slide-content-link');
  slideshowButtons.forEach(function(target) {
    if(target.href.includes('/pages/ofertas')) {
      target.closest('.slideshow__slide.carousel__slide').classList.add('ofertas-parent');
    }
  });
  /*END Check href button and add class to closest slide chosen */
  

 /*Modificar texto del primer slide*/
  /* const deleteLine = document.querySelector('.flickity-slider .slideshow__slide:nth-child(1) .slideshow__slide-inner h1.split-text .line-parent:nth-child(2)');
   deleteLine.remove();
  
  let currentSlide = document.querySelector('.flickity-custom-navigation--current');
  let observer = new MutationObserver(mutationRecords => {
    if(currentSlide.innerHTML === '1') {
      changeH1();
    }
    //observer.disconnect();
  });
  
  // observa todo exceptuando atributos
  observer.observe(currentSlide, {
    childList: true, // observa hijos directos
    subtree: false, // y descendientes inferiores también
    characterDataOldValue: true // pasa el dato viejo al callback
  });

  changeH1(); */
  
  /*END Modificar texto del primer slide*/

} //END if (window.location.href === 'https://www.ufesa.es/')

/* function changeH1() {
  const titleTxt = document.querySelector('.flickity-slider .slideshow__slide:nth-child(1) .slideshow__slide-inner h1.split-text .line-child');
  titleTxt.innerHTML = 'Toda la vida regalándote tiempo';
  setTimeout(() => {
    titleTxt.style.cssText = 'transition: all 0.3s;opacity: 0';
  }, "5000");
  setTimeout(() => {
    titleTxt.style.cssText = 'transition: all 0.6s;opacity: 1;';
    titleTxt.innerHTML = 'Feliz Día de la Madre';
  }, "5400");
} */



// Activa el popup de klaviyo
/* if (window.location.href === 'https://www.ufesa.es/collections/freidoras-de-aire') {


  let elem = document.querySelector('ul.products');
  let observer = new MutationObserver(mutationRecords => {
    console.log(mutationRecords); // console.log(los cambios)

    trigerKlaviyo();
    //observer.disconnect();
  });
  
  // observa todo exceptuando atributos
  observer.observe(elem, {
    childList: true, // observa hijos directos
    subtree: false, // y descendientes inferiores también
    characterDataOldValue: true // pasa el dato viejo al callback
  });
 


  trigerKlaviyo();

  var is_iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (is_iOS) {
    const promotionTargets = document.querySelectorAll('.promotion-column a');
    promotionTargets.forEach(function(target) {
        target.addEventListener('touchstart touchmove touchend', function(e) {
            e.preventDefault();
            window._klOnsite = window._klOnsite || []; 
            window._klOnsite.push(['openForm', 'VHaRKV']);
        });
    });
  }  
}

function trigerKlaviyo() {
  const promotionTargets = document.querySelectorAll('.promotion-column a');
  promotionTargets.forEach(function(target) {

      target.removeAttribute('href');
      target.ontouchstart = null;
    
      target.onclick = null;
    
      target.addEventListener('click', function(e) {
          e.preventDefault();
          window._klOnsite = window._klOnsite || []; 
          window._klOnsite.push(['openForm', 'VHaRKV']);
      });
  });
}
 */

if (window.location.href === 'https://www.ufesa.es/pages/preguntas-frecuentes') {
  const triggerKlaviyo = document.getElementById('triggerKlaviyo');
  triggerKlaviyo.style.cssText = 'text-decoration: underline;cursor: pointer;';
  triggerKlaviyo.addEventListener('click', function(e) {
      e.preventDefault();
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', 'VHaRKV']);
  });
}

if (window.location.href.includes('pages/rebaixes') || window.location.href.includes('pages/cyber-monday') || window.location.href.includes('pages/black-friday') || window.location.href.includes('pages/rebajas') || window.location.href.includes('pages/navidad')) {
      const triggerKlaviyo = document.querySelector('.rich-text__inner .rte p strong');
      triggerKlaviyo.style.cssText = 'text-decoration: underline;cursor: pointer;font-weight: 400;';
      triggerKlaviyo.addEventListener('click', function(e) {
          e.preventDefault();
          window._klOnsite = window._klOnsite || []; 
          window._klOnsite.push(['openForm', 'VHaRKV']);
      });
}


if (window.location.href.includes('cambios-y-devoluciones')) {
    document.addEventListener('DOMContentLoaded', function () {
      const elem = document.querySelector('div[data-forms-id="forms-root-351350"]');
      const FORM_SELECTOR = 'form-embed#app-embed';
    
      if (!elem) {
        console.warn('⚠️ Nodo contenedor no encontrado');
        return;
      }
    
      function ejecutarLogica() {
        const shadowHost = document.querySelector(FORM_SELECTOR);
        if (!shadowHost) return;
    
        const shadowRoot = shadowHost.shadowRoot;
        if (!shadowRoot) return;
    
        const numPedido = shadowRoot.querySelector('input[id*="nmero_de_pedido"]');
        if (!numPedido) return;
    
        console.log("✅ Ejecutando lógica sobre form-embed");
    
        const textareaDevolucion = shadowRoot.querySelector('form textarea[name*="motivo"]');
        if (textareaDevolucion) {
          textareaDevolucion.parentElement.style.cssText = 'display: none;';
          textareaDevolucion.dispatchEvent(new Event('input', { bubbles: true }));
        }
    
        const numPedidoLabel = shadowRoot.querySelector('label[for*="nmero_de_pedido"]');
        if (numPedidoLabel) {
          numPedidoLabel.style.cssText = 'transform: var(--input-label-transform); width: 100%; min-width: 0;';
        }
    
        const form = shadowRoot.querySelector('form');
        if (!form) return;
    
        const fechaCompraLabel = form.querySelector('[data-testid="date-birthday"] ._birthdayText_rzr7e_15');
        if (fechaCompraLabel) {
          fechaCompraLabel.innerHTML = 'Fecha de la compra*<br/><span style="font-size:13px;font-style: italic;color: grey;">Recuerde que solo se aceptarán las devoluciones los primeros 14 días tras la fecha de compra.</span>';
        }
    
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.style.cssText = 'padding: 17.313px;font-weight: 500;';
    
        const disclaimer = shadowRoot.querySelector('[class*="_formDisclaimer_"]');
        if (disclaimer) disclaimer.style.cssText = 'text-align: left;font-size: 11px;';
    
        const inputs = form.querySelectorAll('input');
        inputs.forEach(input => {
          input.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          input.addEventListener('focus', () => {
            if (input.matches(':focus-visible')) input.style.cssText += 'box-shadow: 0 0 0 2px #2c2d2e;';
          });
          input.addEventListener('blur', () => {
            input.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          });
        });
    
        const inputDni = form.querySelector('#custom#dni');
        if (inputDni) {
          inputDni.addEventListener('input', function () {
            if (this.value.length > 9) {
              this.value = this.value.substring(0, 9);
            }
          });
        }
    
        const selectors = form.querySelectorAll('button[aria-controls]');
        selectors.forEach(selector => {
          const valorDefecto = document.createElement('span');
          valorDefecto.textContent = 'Elige una opción';
          valorDefecto.style.cssText = 'display: block;width: 100%;';
          selector.prepend(valorDefecto);
    
          const spans = selector.querySelectorAll('span');
          const textElement = spans.length >= 2 ? spans[1] : null;
    
          selector.style.cssText = 'border-radius: 4px;max-height: 50px;height: 50px;';
          selector.addEventListener('click', () => {
            if (selector.matches("[aria-expanded='false']")) {
              selector.style.cssText += 'box-shadow: 0 0 0 2px #2c2d2e;';
            } else {
              selector.style.cssText = 'border-radius: 4px;max-height: 50px;height: 50px;';
            }
          });
    
          const observerSelector = new MutationObserver(() => {
            if (!textElement) return;
    
            valorDefecto.style.display = textElement.textContent.trim() === '' ? 'block' : 'none';
    
            if (
              selector.getAttribute('aria-controls') === 'custom#motivo_de_la_devolucin-selector-dropdown' &&
              textareaDevolucion
            ) {
              const value = textElement.textContent.trim();
              textareaDevolucion.parentElement.style.cssText =
                value === 'Otro (describir)' ? 'display: flex;' : 'display: none;';
            }
          });
    
          observerSelector.observe(selector, { childList: true, subtree: true });
        });
    
        const textareas = form.querySelectorAll('textarea');
        textareas.forEach(area => {
          area.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          area.addEventListener('focus', () => {
            if (area.matches(':focus-visible')) area.style.cssText += 'box-shadow: 0 0 0 2px #2c2d2e;';
          });
          area.addEventListener('blur', () => {
            area.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          });
        });
      }
    
      // Espera activa si se inserta dinámicamente
      function esperarYejecutarLogica(intentos = 20) {
        const shadowHost = document.querySelector(FORM_SELECTOR);
        if (!shadowHost || !shadowHost.shadowRoot) {
          if (intentos > 0) {
            return setTimeout(() => esperarYejecutarLogica(intentos - 1), 200);
          } else {
            console.warn('⛔ No se cargó el shadowRoot tras varios intentos.');
            return;
          }
        }
    
        const shadowRoot = shadowHost.shadowRoot;
        const numPedido = shadowRoot.querySelector('input[id*="nmero_de_pedido"]');
    
        if (!numPedido) {
          if (intentos > 0) {
            return setTimeout(() => esperarYejecutarLogica(intentos - 1), 200);
          } else {
            console.warn('⛔ Input "custom#nmero_de_pedido" no encontrado tras varios intentos.');
            return;
          }
        }
    
        console.log('✅ Ejecutando lógica tras espera activa');
        ejecutarLogica();
      }
    
      const formAlreadyInDOM = document.querySelector(FORM_SELECTOR);
    
      if (formAlreadyInDOM) {
        console.log('✅ form-embed ya está en el DOM, ejecutando lógica directamente');
        esperarYejecutarLogica();
      } else {
        console.log('⌛ Esperando que se inserte form-embed…');
    
        const observer = new MutationObserver(mutations => {
          for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1 && node.matches(FORM_SELECTOR)) {
                console.log('📢 Mutación detectada: form-embed insertado');
                observer.disconnect();
                esperarYejecutarLogica();
                break;
              }
            }
          }
        });
    
        observer.observe(elem, { childList: true });
      }
    });//DOMContentLoaded
  
}

if (window.location.href.includes('/ofertas') && window.matchMedia('(max-width: 768px)').matches) {
  document.addEventListener('DOMContentLoaded', function() {
    const getHeight = document.querySelector('.rich-text')?.offsetHeight || 0;
    const spaceSection = document.querySelector('[id*="dcan_promotion_blocks"] .multicolumn');
    if (spaceSection) {
      spaceSection.style.cssText += `padding-top: ${getHeight + 20}px;`;
    }
  });
}


/* if(window.location.href.indexOf('/articles') > -1) {
  document.addEventListener('DOMContentLoaded', function() {
    const imgElement = document.querySelectorAll('.post-content img');
    imgElement.forEach(function(target, index) {
      
      let imgWrapper = '';
      if(target.closest('p')) {
        imgWrapper = target.closest('p');
      } else if(target.closest('div')) {
        imgWrapper = target.closest('div');
      }
      const imgPrevNode = imgWrapper.previousElementSibling;
      const spanElement = document.createElement('span');
      if(!target.style.float){
        spanElement.append(imgPrevNode.cloneNode(true));
        spanElement.append(imgWrapper);
        imgPrevNode.replaceWith(spanElement);
  
        target.style.cssText = 'width: 100%;';
        if (window.matchMedia('(min-width: 768px)').matches) {
          spanElement.style.cssText = 'width: 100%;display: grid;grid-template-columns: repeat(2, 1fr);gap: 2rem;';
        }
        window.addEventListener('resize', function(event) {
          if (window.matchMedia('(min-width: 768px)').matches) { 
            spanElement.style.cssText = 'width: 100%;display: grid;grid-template-columns: repeat(2, 1fr);gap: 2rem;';
          } else {
            spanElement.style.cssText = 'width: 100%;display: grid;grid-template-columns: repeat(1, 1fr);';
          }
        });
      }
      if(target.style.float === 'right') {
        target.classList.add('float-right');
      } else if(target.style.float === 'left')  {
        target.classList.add('float-left');
      }

      
    }); //forEach function
  
  }); //DOMContentLoaded
} */